import React from 'react';
import { avatarColour, initialsOf } from './utils/visitorStatsHelpers';

export const ANON = { key: 'anonymous', name: 'Anonymous visitor', email: null };

/** Avatar + name + e-mail for a signed-in user, or a grey "?" for an anonymous visitor. */
export function UserBadge({ user }) {
  const anonymous = user.key === ANON.key;
  return (
    <span className="vs-who">
      <span className="vs-avatar vs-avatar--sm" style={{ background: anonymous ? '#4b5563' : avatarColour(user.key) }} aria-hidden="true">
        {anonymous ? '?' : initialsOf(user.name, user.email)}
      </span>
      <span className="vs-who-text">
        <span className="vs-who-name">{user.name}</span>
        {user.email && user.email !== user.name && <span className="vs-who-email">{user.email}</span>}
      </span>
    </span>
  );
}
